// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snubbull: PokeData = {
  "id": 209,
  "name": "snubbull",
  "height": 6,
  "weight": 78,
  "base_experience": 60,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "tail-whip",
    "bite",
    "growl",
    "roar",
    "rage",
    "lick",
    "scary-face",
    "charm",
    "crunch",
    "taunt",
    "payback",
    "last-resort",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "play-rough"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "growl",
    "lick",
    "scary-face",
    "crunch",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "play-rough",
    "starfall",
    "moonblast"
  ],
  "evolution_chain": {
    "id": 105,
    "item": null,
    "species": [
      {
        "name": "snubbull",
        "order": 240,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "granbull",
        "order": 241,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 209,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 23,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 30,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
